import React, { useState, useEffect } from 'react';
import { Admin, Resource } from 'react-admin';

import polyglotI18nProvider from 'ra-i18n-polyglot';
import './App.css';

import authProvider from './authProvider';
import themeReducer from './themeReducer';
import menuLayoutReducer from './menuLayoutReducer';
import { Login, Layout } from './layout';
import { Dashboard } from './dashboard';
import customRoutes from './routes';
import englishMessages from './i18n/en';

import donors from './donors';
import shipments from './shipments';
import packings from './packings';
import users from './users';
import passwords from './passwords'
import importexports from './importexports';
import phleboto from './phleboto';
import deferralexp from './deferralexp'
import sixmonths from './sixmonths'
import noshow from './noshow'
import toship from './toship'
import chart from './chart'
import processing from './processing'
import physicals from './physical'
import dataProviderFactory from './dataProvider';
import spe from './spe';
import absc from './absc';
import bleedLogs from './bleedLogs';
import readyshipping from './readyshipping';
import quarantine from './quarantine'
import reactive from './reactive'
import questions from './questions'
import registration from './registration'
import samples from './samples'
import sampleboxes from './sampleBox'
import downloads from './downloads'
import fileview from './downloads/Files'
import samplesextra from './samples/extra'
import setuptrainings from './setuptrainings'
import trainings from './trainings'
import equipregister from './equipregister'
import instruments from './instruments'
import setupquestions from "./setupquestions"
import setuprecertificate from "./setuprecertificate"
import certifications from "./certifications"
import examlogs from "./examlogs"
import examhistory from "./examhistory"
import setupchecklist from "./setupCheckLists"
import checklist from './checklist'
import userslist from './userslist'
import recertificate from './recertificate'
import logs from './logs'
import calinstrument from './calinstrument';
import valinstrument from './valinstrument';
import maiinstrument from './maiinstrument';
import loginstrument from './loginstrument';
import cal_MICRO_CENT_d from './templates/cal_MICRO_CENT_d'
import cal_REFRA_METR_d from './templates/cal_REFRA_METR_d';
import cal_STOP_WATCH_a from './templates/cal_STOP_WATCH_a'
import val_REFRA_METR_o from './templates/val_REFRA_METR_o'
import main_AURORA_m from './templates/main_AURORA_m'
import log_EQ_INC from './templates/log_EQ_INC';
import lookback from './lookback'
import donhistory from './donhistory';
import cdcsdonations from './cdcsdonations'
import ErrorBoundary from './ErrorBoundary';
import holidays from './settings/HolidayResource';
import aSettings from './settings/AppointmentSettingResource';
import appointment from './appointments/AppointmentResource';
import readydispose from './readydispose';
import disposals from './disposals';
import supplyinventory from './supplyinventory';
import supplylots from './supplylots';
import supplyreceipts from './supplyreceipts';
import supplyshipments from './supplyshipments';
import supplyadjustments from './supplyadjustments';
import supplytypes from './supplytypes';
import supplyvendors from './supplyvendors';

import customDataProvider from "./dataProvider/CustomDataProvider";

const i18nProvider = polyglotI18nProvider(() => englishMessages, 'en');

const App = () => {

    const [dataProvider, setDataProvider] = useState(null);
    const {REACT_APP_API_ENDPOINT} = process.env;
    useEffect(() => {
        let restoreFetch;

        const fetchDataProvider = async () => {
            try {
                const mainProvider = await dataProviderFactory(process.env.REACT_APP_DATA_PROVIDER);
                const holidaysProvider = customDataProvider(REACT_APP_API_ENDPOINT );

                if (mainProvider && mainProvider.restore) {
                    restoreFetch = mainProvider.restore;
                }

                // Combine the data providers
                const combinedDataProvider = {
                    ...mainProvider,
                    getList: (resource, params) => {
                        console.log("current resource", resource);
                        if (resource.startsWith('appointment/')) {
                            return holidaysProvider.getList(resource, params);
                        }
                        return mainProvider.getList(resource, params);
                    },
                    getOne: (resource, params) => {
                        console.log("current resource", resource);
                        if (resource.startsWith('appointment/')) {
                            return holidaysProvider.getOne(resource, params);
                        }
                        return mainProvider.getOne(resource, params);
                    },
                    create: (resource, params) => {
                        console.log("current resource", resource);
                        if (resource.startsWith('appointment/')) {
                            return holidaysProvider.create(resource, params);
                        }
                        return mainProvider.create(resource, params);
                    },
                    update: (resource, params) => {
                        console.log("current resource", resource);
                        if (resource.startsWith('appointment/')) {
                            return holidaysProvider.update(resource, params);
                        }
                        return mainProvider.update(resource, params);
                    },
                    delete: (resource, params) => {
                        console.log("current resource", resource);
                        if (resource.startsWith('appointment/')) {
                            return holidaysProvider.delete(resource, params);
                        }
                        return mainProvider.delete(resource, params);
                    }
                };

                setDataProvider(combinedDataProvider);
            } catch (error) {
                console.error("Failed to initialize data provider:", error);
            }
        };

        fetchDataProvider();

        return () => {
            if (restoreFetch) {
                restoreFetch();
            }
        };
    }, []);

    if (!dataProvider) {
        return (
            <div className="loader-container">
                <div className="loader">Loading...</div>
            </div>
        );
    }
    return (
        <ErrorBoundary>  
            <Admin 

                dataProvider={dataProvider}
                customReducers={{ theme: themeReducer, menuLayout: menuLayoutReducer }}
                customRoutes={customRoutes}
                authProvider={authProvider}
                dashboard={Dashboard}
                loginPage={Login}
                appLayout={Layout}
                locale="en"
                i18nProvider={i18nProvider}


                >

                <Resource  name="donors"             { ...donors}/>
                <Resource  name="packings"           {...packings}/>
                <Resource  name="shipments"          {...shipments}/>
                <Resource  name="users"              {...users}/>
                <Resource  name="passwords"          {...passwords}/>
                <Resource  name="importexports"      {...importexports}/>
                <Resource  name="deferralexp"        {...deferralexp}/>
                <Resource  name="sixmonths"          {...sixmonths}/>
                <Resource  name="noshow"             {...noshow}/>
                <Resource  name="toship"             {...toship}/>
                <Resource  name="chart"              {...chart}/>
                <Resource  name="processing"         {...processing}/>
                <Resource  name="physicals"          {...physicals} />
                <Resource  name="spe"                {...spe} />
                <Resource  name="absc"               {...absc} />
                <Resource  name="phleboto"           {...phleboto} />
                <Resource  name="bleedLogs"          {...bleedLogs} />
                <Resource  name="readyshipping"      {...readyshipping}/>
                <Resource  name="readydispose"       {...readydispose}/>
                <Resource  name="disposals"        {...disposals}/>
                <Resource  name="quarantine"         {...quarantine}/>
                <Resource  name="reactive"           {...reactive}/>
                <Resource  name="questions"          {...questions} />
                <Resource  name="registration"       {...registration} />
                <Resource  name="samples"            {...samples} /> 
                <Resource  name="samplesextra"       {...samplesextra} />
                <Resource  name="sampleboxes"        {...sampleboxes} />
                <Resource  name="downloads"          {...downloads} />
                <Resource  name="fileview"           {...fileview} />
                <Resource  name="setuptrainings"     {...setuptrainings} />
                <Resource  name="setuprecertificate" {...setuprecertificate} />
                <Resource  name="setupquestions"     {...setupquestions} />
                <Resource  name="trainings"          {...trainings} />
                <Resource  name="equipregister"      {...equipregister} />
                <Resource  name="instruments"        {...instruments} />
                <Resource  name="certifications"     {...certifications} />
                <Resource  name="examlogs"           {...examlogs} />
                <Resource  name="examhistory"        {...examhistory} />
                <Resource  name="setupchecklist"     {...setupchecklist} />
                <Resource  name="checklist"          {...checklist} />
                <Resource  name="userslist"          {...userslist} />
                <Resource  name="recertificate"      {...recertificate} />
                <Resource  name="logs"               {...logs} />
                <Resource  name="calinstrument"      {...calinstrument} />
                <Resource  name="valinstrument"      {...valinstrument} />
                <Resource  name="maiinstrument"      {...maiinstrument} />
                <Resource  name="loginstrument"      {...loginstrument} /> 
                <Resource  name="cal_MICRO_CENT_d"   {...cal_MICRO_CENT_d} /> 
                <Resource  name="cal_REFRA_METR_d"   {...cal_REFRA_METR_d} /> 
                <Resource  name="cal_STOP_WATCH_a"   {...cal_STOP_WATCH_a} /> 
                <Resource  name="val_REFRA_METR_o"   {...val_REFRA_METR_o} />
                <Resource  name="main_AURORA_m"      {...main_AURORA_m} />
                <Resource  name="log_EQ_INC"         {...log_EQ_INC} />
                <Resource  name="lookback"           {...lookback} />
                <Resource  name="donhistory"         {...donhistory} />
                <Resource name="cdcsdonations"       {...cdcsdonations} />
                <Resource  name="supplyinventory"     {...supplyinventory} />
                <Resource  name="supplylots"          {...supplylots} />
                <Resource  name="supplyreceipts"      {...supplyreceipts} />
                <Resource  name="supplyshipments"     {...supplyshipments} />
                <Resource  name="supplyadjustments"   {...supplyadjustments} />
                <Resource  name="supplysublots" />
                <Resource  name="supplycategories" />
                <Resource  name="supplytypes"         {...supplytypes} />
                <Resource  name="supplyvendors"       {...supplyvendors} />
                <Resource name="appointment/holidays"{...holidays} />
                <Resource name="appointment/appointment-settings" {...aSettings} />
                <Resource name="appointment/appointments" {...appointment} />

            </Admin>
        </ErrorBoundary>  
    
    );
}
export default App;